require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ./~/angular-cookies/index.js
// module id = 623
// module chunks = 1